import { render } from "./z-status.vue?vue&type=template&id=5a460912"
import script from "./z-status.vue?vue&type=script&lang=js"
export * from "./z-status.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__